import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import App from './App'
import './index.css'
import { persistCache } from 'apollo-cache-persist'
import { ApolloProvider } from '@apollo/react-hooks'
import { createUploadLink } from 'apollo-upload-client'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { GET_USER_ACCESS, TOKEN } from './_query'
import { URI_API, URI_WS } from './globalFunc'
import { onError } from "apollo-link-error"
import { WebSocketLink } from 'apollo-link-ws'
import { split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'

const cache = new InMemoryCache()

const httpLink = createUploadLink({
    uri: `${URI_API}/graphql`,
})

const wsLink = new WebSocketLink({
    uri: `${URI_WS}/graphql`,
    options: {
        reconnect: true
    },
})

const authLink = setContext(async (_, { headers }) => {
    try {
        const { token } = await cache.readQuery({ query: TOKEN })
        return {
            headers: {
                ...headers,
                authorization: token ? `Bearer ${token}` : "",
            }
        }
    } catch (error) {
        return {
            headers: {
                ...headers
            }
        }
    }
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
            ),
        )

    if (networkError) console.log(`[Network error]: ${networkError}`)
})

let linkConcated = authLink.concat(httpLink, wsLink, errorLink);

const link = split(
    // split based on operation type
    ({ query }) => {
        const { kind, operation } = getMainDefinition(query);
        return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    linkConcated,
);

persistCache({ cache, storage: window.localStorage }).then(() => {
    const client = new ApolloClient({
        link,
        resolvers: {
            Query: {
                getAccess(_, { view }, { cache }) {
                    let { user } = cache.readQuery({ query: GET_USER_ACCESS })
                    let access = user.role.access.filter(a => a.view.name === view)[0]
                    return access
                }
            },
            Mutation: {
                logOut: (_, { state }, { cache }) => {
                    cache.writeData({ data: { user: null, token: null, exp: null } })
                    return state
                },
                updateMenu: (_, { showMenu }, { cache }) => {
                    cache.writeData({ data: { showMenu: showMenu === undefined ? true : showMenu } })
                    return null
                },
                updateScroll: (_, { scroll }, { cache }) => {
                    cache.writeData({ data: { scroll: scroll === undefined ? 0 : scroll } })
                    return null
                },
                updateQuoteRequestList: (root, { updateQuoteList }, { cache }) => {
                    if (updateQuoteList) {
                        cache.writeData({ data: { updateQuoteList: updateQuoteList } })
                    } else {
                        cache.writeData({ data: { updateQuoteList: false } })
                    }
                }
            }
        },
        cache
    })

    ReactDOM.render(
        <ApolloProvider client={client}>
            <App />
        </ ApolloProvider >, document.getElementById('root'))

    serviceWorker.unregister()
})


